import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

export class WbVideo {
  constructor() {
    gsap.registerPlugin(ScrollTrigger);
  }

  init() {
    return new Promise((resolve, reject) => {
      this.bindListeners();
      resolve();
    });
  }

  bindListeners() {
    const _this = this;

    document.querySelector('body')._addCustomEventListener('click', '.wb-video__play', _this.togglePlay.bind(_this));
    document.querySelector('body')._addCustomEventListener('click', '.wb-video__pause', _this.togglePlay.bind(_this));
    document.querySelector('body')._addCustomEventListener('click', '.wb-video__mute', _this.toggleSound.bind(_this));

    document.querySelectorAll?.('figure.media oembed')?.forEach(video => {
      _this.viewVideo(video);
    });

    this.videoTrigger();
  }

  viewVideo(e) {
    const _this = this;
    const ele = e.targetElement;
    var parentEle = e.parentNode;
    const url = e.getAttribute('url');
    parentEle.removeChild(e);

    parentEle.innerHTML =
      '<span class="wb-image-oembed"><span class="wb-image wb-image--ratio wb-image--ratio--16-9" ><iframe  src="' +
      url.replace('watch?v=', 'embed/') +
      '"  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe></span></span>' +
      parentEle.innerHTML;
  }

  togglePlay(e) {
    const _this = this;
    const ele = e.targetElement;
    const wrapper = ele.closest?.('.wb-video');

    if (ele.classList.contains('wb-video__play'))
      document.querySelectorAll?.('.wb-video--playing')?.forEach(video => {
        _this.changeVideoStatus(video);
      });

    _this.changeVideoStatus(wrapper);
  }

  changeVideoStatus(parent) {
    const videoPlayer = parent?.querySelector('.wb-video__video-player');

    if (videoPlayer) {
      if (parent.classList.contains('wb-video--playing')) {
        this.videoState(parent, false);
      } else {
        this.videoState(parent, true);
      }
    }
  }

  videoState(parent, isPlaying = false) {
    const videoPlayer = parent?.querySelector('.wb-video__video-player');
    const controlPlay = parent?.querySelector('.--control-play');
    const controlPause = parent?.querySelector('.--control-pause');
    const controlVolume = parent?.querySelector('.--control-volume');

    if (isPlaying) {
      videoPlayer.muted = true;
      videoPlayer.play();
      parent.classList.add('wb-video--muted');
      parent.classList.add('wb-video--playing');
      controlPlay._slideUp();
      controlPause._slideDown();
      controlVolume._slideDown();
    } else {
      videoPlayer.pause();
      parent.classList.remove('wb-video--playing');
      controlPlay._slideDown();
      controlPause._slideUp();
      controlVolume._slideUp();
    }
  }

  toggleSound(e) {
    const ele = e.targetElement;
    const wrapper = ele.closest?.('.wb-video');
    const videoPlayer = wrapper?.querySelector('.wb-video__video-player');

    if (videoPlayer) {
      wrapper.classList.toggle('wb-video--muted');
      videoPlayer.muted = wrapper.classList.contains('wb-video--muted');
    }
  }

  videoTrigger() {
    for (const video of document.querySelectorAll('.wb-video .--autoplay-video')) {
      const videoWrapper = video?.closest('.wb-video');
      ScrollTrigger.create({
        trigger: video,
        onEnter: () => this.videoState(videoWrapper, true),
        onEnterBack: () => this.videoState(videoWrapper, true),
        onLeave: () => this.videoState(videoWrapper, false),
        onLeaveBack: () => this.videoState(videoWrapper, false),
      });
    }
  }
}
